import React from 'react'
import { FiMenu } from 'react-icons/fi'
import { MenuLinkItem } from '../../../../../components/Template/Header'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'

function ToggleMenu({
  isSidebarOpen,
  toggleSidebar,
  className,
  size = 1,
}: IToggleMenuProps & IToggleMenuDispatch & IWithSize) {
  return (
    <MenuLinkItem
      size={size}
      className={className}
      onClick={toggleSidebar}
      center={true}
      active={isSidebarOpen}
      style={{ padding: `0 ${0.6 * size}em` }}
    >
      <FiMenu />
    </MenuLinkItem>
  )
}

export default ToggleMenu

export interface IToggleMenuProps {
  isSidebarOpen?: boolean
  className: string
}

export interface IToggleMenuDispatch {
  toggleSidebar: () => void
}
